import { render, staticRenderFns } from "./SalesDashboard.vue?vue&type=template&id=55787408"
import script from "./SalesDashboard.vue?vue&type=script&lang=js"
export * from "./SalesDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55787408')) {
      api.createRecord('55787408', component.options)
    } else {
      api.reload('55787408', component.options)
    }
    module.hot.accept("./SalesDashboard.vue?vue&type=template&id=55787408", function () {
      api.rerender('55787408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/SalesDashboard.vue"
export default component.exports